import React from 'react'
import { CREATE_MOCK_PROVIDERS } from '@dx-private/dxchart5-react-mock-providers'
import { LicensedChartWidgetHost } from '../components/LicensedChartWidgetHost'

const DUMMY_SYMBOL = 'AAPL'

/** Offline licensed chart for iframe gesture tests; no backend connection is used. */
export function DummyAaplChart(): React.ReactElement {
  const dependencies = React.useMemo(() => {
    const mockProviders = CREATE_MOCK_PROVIDERS() as any

    return {
      ...mockProviders,
      initialInstrument: DUMMY_SYMBOL,
      chartReactConfig: {
        ...(mockProviders.chartReactConfig ?? {}),
        trading: {
          ...(mockProviders.chartReactConfig?.trading ?? {}),
          enabled: false,
        },
      },
    }
  }, [])

  return (
    <main style={{ width: '100%', height: '100%', overflow: 'hidden' }} data-testid="dummy-aapl-chart">
      <LicensedChartWidgetHost dependencies={dependencies} className="dummy-aapl-chart__host" />
    </main>
  )
}
